export default __webpack_public_path__ + "static/media/cif-se.814b8416.svg";